import { useEffect } from 'react'

import { NOTIFICATION_TYPE } from '@/src/features/notification/models/notification.constants'
import { useMarkNotificationAsReadMutation } from '@/src/features/notification/services/useMarkNotificationAsReadMutation'
import { useNotificationsQuery } from '@/src/features/notification/services/useNotificationsQuery'

export const IntentionMarkAsRead = () => {
  const { data } = useNotificationsQuery()
  const { mutateAsync } = useMarkNotificationAsReadMutation()

  useEffect(() => {
    if (data?.some(({ type }) => type === NOTIFICATION_TYPE.NEW_PRAYER_ON_INTENTION)) {
      setTimeout(() => {
        mutateAsync(NOTIFICATION_TYPE.NEW_PRAYER_ON_INTENTION)
      }, 4000)
    }
  }, [mutateAsync, data])

  return null
}
